import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const colors = {
  primary: "#0a4a8e",
  success: "#28a745",
  warning: "#ffc107",
  danger: "#dc3545",
};

const HChartStyle = styled.div`
  height: ${props => props.height || "300px"};
  width: 100%; /* Usando 100% para ocupar toda a largura do container pai */
  display: flex;
  overflow-x: auto; /* Permite rolagem horizontal */
  background-color: #f5f5f5;
  border-radius: 4px;
  position: relative;
  flex: 1; /* Ocupa todo o espaço disponível horizontalmente */
  margin: 0; /* Removendo margens */
  padding: 0; /* Removendo preenchimentos */
`;

export const HorizontalBarChart = (props) => {

  const { t } = useTranslation();


  const renderTooltip = (d) => {
    return d.filial + ": " + d.onlate + " " + t('INCONSISTENT.ON_LATE') + ", " + d.ontime + " " + t('INCONSISTENT.ON_TIME') + ", " + d.pending + " " + t('INCONSISTENT.PENDING');
  }

  let data = props.data;
  const max = Math.max(Math.max(...data.map(o => o.onlate)),
    Math.max(...data.map(o => o.ontime)),
    Math.max(...data.map(o => o.pending)));

  let orderedData = [].concat(data);
  if (props.orderGroup) {
    orderedData = [].concat(data)
      .sort((a, b) => a.regional > b.regional ? 1 : -1);
  }

  const regionals = [];
  orderedData.map(dt => {
    if (regionals.indexOf(dt.regional) === -1) {
      regionals.push(dt.regional)
    }
  });

  return (
    <div>
      <div style={{ display: "flex", gap: "5px", marginBottom: "10px", float: "right" }}>
        <div style={{ background: colors.primary, width: "15px", height: "15px", borderRadius: "3px", marginLeft: "5px" }}></div><span style={{ lineHeight: "15px" }}>{t('INCONSISTENT.ON_LATE')}</span>
        <div style={{ background: colors.success, width: "15px", height: "15px", borderRadius: "3px", marginLeft: "5px" }}></div><span style={{ lineHeight: "15px" }}>{t('INCONSISTENT.ON_TIME')}</span>
        <div style={{ background: colors.danger, width: "15px", height: "15px", borderRadius: "3px", marginLeft: "5px" }}></div><span style={{ lineHeight: "15px" }}>{t('INCONSISTENT.PENDING')}</span>
      </div>
      <HChartStyle>
        <div style={{ width: '30px', marginBottom: '50px', marginRight: "5px", textAlign: "left", position: "relative" }}>
          <div style={{ position: "absolute", right: '5px', bottom: "-20px" }}>0</div>
          <div style={{ height: "20%" }}>{(max).toFixed(1)}</div>
          <div style={{ height: "20%" }}>{(max * 0.8).toFixed(1)}</div>
          <div style={{ height: "20%" }}>{(max * 0.6).toFixed(1)}</div>
          <div style={{ height: "20%" }}>{(max * 0.4).toFixed(1)}</div>
          <div style={{ height: "20%" }}>{(max * 0.2).toFixed(1)}</div>
        </div>
        <div style={{ display: 'flex', width: "100%", marginBottom: '50px' }}>
          {orderedData.map(d =>
            <div style={{ height: "100%" }}>
              <div
                title={renderTooltip(d)}
                style={{
                  display: 'flex',
                  height: '100%',
                  paddingLeft: `${props.showTotals ? "50px" : "5px"}`,
                  paddingRight: `${props.showTotals ? "50px" : "5px"}`,
                  alignItems: 'flex-start',
                  background: "repeating-linear-gradient(0deg, #AAA0 0 calc((100% - 5*1px)/5), #AAA  0 calc((100% - 5*1px)/5 + 1px))"
                }}
              >
                <div style={{ background: colors.primary, height: d.onlate * 100 / max + "%", width: "33%", margin: "1px", marginLeft: "0px", marginTop: 'auto' }}></div>
                <div style={{ background: colors.success, height: d.ontime * 100 / max + "%", width: "33%", margin: "1px", marginLeft: "0px", marginTop: 'auto' }}></div>
                <div style={{ background: colors.danger, height: d.pending * 100 / max + "%", width: "33%", margin: "1px", marginLeft: "0px", marginTop: 'auto' }}></div>
                  </div>
                  {/* Sprint 32000
                    Passando a informação do total, para mudar o widht, de quando ele é clicado
                    E assim fazendo ele ocupar 100% da tela
                  */}
              <div style={{ display: 'flex', justifyContent: 'center', height: '30px', width: `${props.showTotals ? "380px" : "85px"}`, borderTop: 'solid 1px' }}>
                {d.filial}
              </div>

            </div>
          )}
        </div>
        {props.groupLegend && <div style={{ position: 'absolute', bottom: '0px', left: '0px', width: (data.length + 1) * 83, height: "30px", display: 'flex', paddingLeft: '30px' }}>
          {regionals.map(r =>
            <div style={{ width: data.filter(x => x.regional == r).length * 85, border: "solid", borderTop: "none", display: "flex", justifyContent: "center", alignItems: "center" }}>Reg. {r}</div>
          )}
        </div>}
      </HChartStyle>
    </div>
  );
};
